import { Variant } from '@collaborator/npm_modules/dist/css/variant';
import app from 'srcJs/App';
import { Alert } from 'ui/alert/Alert';
import * as React from 'react';
export var SentAlert = function SentAlert(_ref) {
  var onClose = _ref.onClose;
  return /*#__PURE__*/React.createElement(Alert, {
    variant: Variant.primary,
    dismissible: true,
    onClose: onClose
  }, /*#__PURE__*/React.createElement("p", {
    className: "mb-0"
  }, app.t('confirm_email_notifier', 'Confirmation Email has been sent!')));
};